export default "__VITE_ASSET__15cb8245__"